import {SxProps} from '@mui/material';

import {orangeColors} from '../../../../layouts/theme/designSystem';

export const styles: Record<string, SxProps> = {
  buttonContainer: {
    borderRadius: '0 !important',
  },
};

export const getTabStyles = (isActive: boolean, overrideStyles?: SxProps): SxProps => {
  const activeColor = 'white';
  const inactiveColor = orangeColors[7];
  const hoverColor = orangeColors[3];

  return {
    height: '68px',
    borderTopRightRadius: '16px !important',
    borderTopLeftRadius: '16px !important',
    borderBottomLeftRadius: '0px !important',
    borderBottomRightRadius: '0px !important',
    justifyContent: 'flex-start',
    textTransform: 'none',
    padding: '16px 24px',
    border: 'none !important',
    backgroundColor: isActive ? activeColor : inactiveColor,
    '&:hover': {
      backgroundColor: hoverColor,
    },
    '&.Mui-selected': {
      backgroundColor: activeColor,
    },
    '&.Mui-selected:hover': {
      backgroundColor: activeColor,
    },
    '&::after': {
      display: 'none',
    },
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
    ...overrideStyles,
  };
};

export const getContentStyles = (overrideStyles?: SxProps): SxProps => ({
  backgroundColor: 'white',
  borderRadius: '0px 0px 16px 16px',
  padding: '24px',
  borderTop: `1px solid ${orangeColors[3]}`,
  ...overrideStyles,
});
